import Signin from '../views/signin'

export default [
  {
    path: '/signin',
    name: "signin",
    component: Signin
  }
]